import { api } from "apiServer"
import { Layout } from "components/common"
import SwiperVideo from "components/SwiperVideo"
import { useEffect, useState } from "react"
import { trackGA } from "lib/func"
import { apiLiveScore } from "api"
function Component({ lists }) {
  const { categories, id, name, thumbnail_banner, description } = lists
  const [isMobile, setIsMobile] = useState(false)

  let isDragging = false
  let startX

  function handleDragStart(e) {
    e.preventDefault()
    isDragging = true
    startX = e.pageX || e.touches[0].pageX
  }

  function handleDrag(e) {
    if (!isDragging) return
    const x = e.pageX || e.touches[0].pageX
    const scrollLeft = e.currentTarget.scrollLeft
    e.currentTarget.scrollLeft = scrollLeft - (x - startX)
    startX = x
  }

  function handleDragEnd() {
    isDragging = false
  }

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 1025) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  useEffect(() => {
    if (id === "esports") {
      trackGA("Esports", "ESPORTS_TAB")
    } else {
      trackGA(name, "CATEGORY")
    }
  }, [])

  return (
    <section className="mb-[46px] 3xl:ml-0 max-sm:mr-0 max-sm:ml-0 max-lg:mr-4 max-lg:ml-4 xl:mr-8 md:mx-4">
      <div
        className={`wapper__slide ${isMobile ? "draggable sticky top-[58.75px] z-30 bg-[#131313]" : ""}`}
        onMouseDown={(e) => handleDragStart(e)}
        onMouseMove={(e) => handleDrag(e)}
        onMouseUp={() => handleDragEnd()}
        onMouseLeave={() => handleDragEnd()}
      >
        <MyImage name={name} thumbnail={thumbnail_banner} description={description} isMobile={isMobile} />
      </div>

      <div className="mx-auto overflow-x-hidden mt-8 max-sm:mt-0 max-sm:px-4 max-lg:mt-5">
        {categories?.length > 0 &&
          categories?.map((item) => {
            const { id, videos } = item
            return (
              <div key={id}>
                {videos?.length > 0 && (
                  <SwiperVideo nextLink={`/topic/detail/${id}`} {...item} type_block={1} isTopic={true} />
                )}
              </div>
            )
          })}
        {!categories?.length > 0 && (
          <div className="flex flex-col gap-2 items-center justify-center py-[193px] text-center">
            <span className="text-[22px] leading-[30px] font-semibold text-white">Nội dung chưa sẵn sàng</span>
            <span className="text-base leading-5 font-normal text-[#c6c6c8]">
              Chúng tôi đang cập nhật nội dung này. Bạn có thể thử lại sau một thời gian nữa.
            </span>
          </div>
        )}
      </div>
    </section>
  )
}
export default Component
Component.Layout = Layout

function renderUrl(base_url, thumbnail, size) {
  if (thumbnail?.includes("http")) return thumbnail
  if (!thumbnail) return "/placeholder_video.svg"
  return `${base_url}${size}/${thumbnail}`
}

function MyImage({ base_url, thumbnail, name, description, isMobile }) {
  return (
    <div className="relative rounded-3xl overflow-hidden max-sm:rounded-none">
      <div className="w-full h-[132px] max-sm:h-[42px] absolute bottom-0 left-0"></div>
      <div className={`bottom-0 left-0 w-full ${isMobile ? "" : "absolute"}`}>
        <div className="flex flex-col w-full gap-1 px-5 pb-5 max-sm:py-2">
          <div
            className={` rounded-xl text-2xl leading-7.5 text-[#FAFAF9] bg-[#1313133D] backdrop-blur-xl bottom-5 font-medium z-10 left-5 ${
              isMobile ? "line-clamp-2" : "absolute py-2 px-4"
            }`}
          >
            {name}
          </div>
          <div className="font-normal text-sm text-secondary line-clamp-1">{description}</div>
        </div>
      </div>
      {!isMobile && (
        <div className="fix_img">
          <img
            placeholder="blur"
            className="w-full rounded-3xl h-[358px] object-cover max-sm:rounded-none"
            src={renderUrl(base_url, thumbnail, "1920x800") || "/placeholder_banner.svg"}
            width={1578}
            height={358}
            alt={name}
          />
        </div>
      )}
    </div>
  )
}

export async function getServerSideProps({ req, query, res }) {
  res.setHeader("Cache-Control", "public, s-maxage=10, stale-while-revalidate=29")
  let lists = [],
    video = {}
  const { cookies } = req
  const { id } = query

  try {
    if (id === "esports") {
      const { success, data } = await api.getDetailTopic(cookies?.accessToken, id, { menu_code: "esports" })
      if (success) {
        lists = data
      }
    } else {
      const { success, data } = await api.getDetailTopic(cookies?.accessToken, id, {})
      if (success) {
        lists = data
      }
    }
  } catch (error) {
    // console.log(error.response)
  }

  return { props: { lists, id } }
}
